import { render, staticRenderFns } from "./credits-purchase.vue?vue&type=template&id=50f5608d&scoped=true&"
import script from "./credits-purchase.vue?vue&type=script&lang=js&"
export * from "./credits-purchase.vue?vue&type=script&lang=js&"
import style0 from "./credits-purchase.vue?vue&type=style&index=0&id=50f5608d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5608d",
  null
  
)

export default component.exports